import { GET, POST, PUT, DELETE } from '@/axios';

//TODO: Revisar la implementación de este provider, si se podría utilizar el api client

export async function getThreats() {

    try {

        const response = await GET('threats');
        return response;

    } catch (error) {

        console.error('Error al obtener amenazas:', error);
        throw error;

    }
}

export async function showThreat(threatId) {

    try {

        const response = await GET(`threat/${threatId}`);
        return response;

    } catch (error) {

        console.error(error);
        throw error;
    }
}

export async function createThreat(threatData) {

    try {

        const response = await POST('threats', threatData);
        return response;

    } catch (error) {

        console.error('Error al crear amenaza:', error);
        throw error;

    }
}

export async function updateThreat(threatData, threatId) {

    try {

        const response = await PUT(`threats/${threatId}`, threatData);
        return response;

    } catch (error) {

        console.error('Error al crear amenaza:', error);
        throw error;

    }
}

export async function deleteThreat(threatId) {

    try {

        const response = await DELETE(`threats/${threatId}`);
        return response;

    } catch (error) {

        console.error('Error al eliminar amenaza:', error);
        throw error;

    }
}

export async function importThreatsFromExcel(file) {

    const response = await POST('threats/import-threats-excel', file, {

        headers: { "Content-Type": "multipart/form-data" },

    });

    return response;

}
